export default __webpack_public_path__ + "static/media/expand_more.701161b4.svg";